var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "jobs",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000001623089660461915490000001884833443133169847_);}\r\n\t.st1{fill:#00B2A8;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.46,
    y: 1.46,
    width: 97.08,
    height: 97.08
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016771544188742029130000005971601557196926398_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "teamwork",
    style: {
      clipPath: "url(#SVGID_00000016771544188742029130000005971601557196926398_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    className: "st1",
    d: "M25.51,60.69V42.15c0-1.34,0.19-2.64,0.55-3.89h-12.5c-2.03,0-3.87,0.82-5.2,2.16 c-1.33,1.33-2.16,3.17-2.16,5.2v14.76c0,1.8,0.66,3.45,1.74,4.74c0.57,0.67,1.25,1.24,2.02,1.67v21.45c0,1.57,1.27,2.84,2.83,2.84 h17.44V71.24C27.25,68.54,25.51,64.71,25.51,60.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    className: "st1",
    d: "M21.53,34.9c6.13,0,11.12-4.99,11.12-11.12s-4.99-11.12-11.12-11.12 c-6.14,0-11.12,4.99-11.12,11.12S15.4,34.9,21.53,34.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    className: "st1",
    d: "M59.75,33.63H39.71c-2.35,0-4.48,0.96-6.02,2.5c-1.54,1.54-2.5,3.67-2.5,6.02v18.54 c0,2.08,0.76,4,2.01,5.48c0.75,0.88,1.66,1.61,2.71,2.13V95.7c0,1.57,1.27,2.84,2.84,2.84h21.96c1.57,0,2.84-1.27,2.84-2.84V68.31 c1.04-0.52,1.97-1.25,2.71-2.13c1.26-1.49,2.01-3.4,2.01-5.48V42.15c0-2.35-0.96-4.48-2.5-6.02 C64.23,34.59,62.1,33.63,59.75,33.63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    className: "st1",
    d: "M49.72,27.95c7.3,0,13.25-5.94,13.25-13.25c0-7.3-5.94-13.25-13.25-13.25 c-7.3,0-13.25,5.94-13.25,13.25C36.48,22.01,42.42,27.95,49.72,27.95z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    className: "st1",
    d: "M91.48,40.41c-1.33-1.33-3.17-2.16-5.2-2.16H73.4c0.36,1.25,0.55,2.55,0.55,3.89v18.54 c0,4.02-1.74,7.85-4.72,10.54v19.81c0.11,0.01,0.22,0.02,0.34,0.02h17.47c1.57,0,2.84-1.27,2.84-2.84V66.78 c0.77-0.43,1.45-1,2.01-1.67c1.09-1.29,1.74-2.94,1.74-4.74V45.61C93.64,43.59,92.81,41.75,91.48,40.41z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    className: "st1",
    d: "M78.3,34.9c6.13,0,11.12-4.99,11.12-11.12S84.43,12.66,78.3,12.66 c-6.14,0-11.12,4.99-11.12,11.12S72.17,34.9,78.3,34.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs-icon.421fbecdf19a223b3591034fc8cab150.svg";
export { ForwardRef as ReactComponent };